import { generateHashFromVariables } from '../../../utils/caching/common/key-generator';
import { inMemoryCache } from '../../../utils/caching/in-memory';

const cache = inMemoryCache<any>();

type LeapQueryRequestProps = {
	query: string;
	product: string;
};

type LeapQueryResponseProps = {
	title: number;
	candidates: string[];
};

export const getLeapQuery = ({
	query,
	product,
}: LeapQueryRequestProps): Promise<LeapQueryResponseProps> => {
	const relativeLeapQueryUrl = `/gateway/api/assist/api/ai/v2/ai-feature/leapquery`;

	const body = {
		ai_feature_input: { query },
	};

	return cache.inMemoryDecorator(generateHashFromVariables({ query }), () =>
		fetch(relativeLeapQueryUrl, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				'Content-Type': 'application/json',
				'X-Product': product,
				'X-Experience-Id': 'query-suggestion',
			},
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
			})
			.then((data) => {
				// return empty skeleton response if response is not ok
				// UI will treat this response as no results
				return data?.ai_feature_output || { title: 0, candidates: [] };
			})
			.catch(() => {
				// return empty skeleton response if response is not ok
				// UI will treat this response as no results
				return { title: 0, candidates: [] };
			}),
	);
};
